const IconLead = ({ className }) => {
    return (
        <svg
            width='22'
            height='36'
            viewBox='0 0 22 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path
                id='Rectangle 7304'
                d='M1 7.57565C1 6.39922 1.68761 5.33136 2.75859 4.84455L9.75859 1.66274C10.5474 1.3042 11.4526 1.3042 12.2414 1.66274L19.2414 4.84455C20.3124 5.33136 21 6.39922 21 7.57565V32C21 33.6569 19.6569 35 18 35H4C2.34315 35 1 33.6569 1 32V7.57565Z'
                stroke='white'
                strokeWidth='2'
            />
            <path
                id='Vector 208'
                d='M5.0862 11.3396C4.58342 11.5682 4.3611 12.161 4.58963 12.6638C4.81817 13.1666 5.41102 13.3889 5.9138 13.1604L5.0862 11.3396ZM10.1724 10.1262L10.5862 11.0366V11.0366L10.1724 10.1262ZM11.8276 10.1262L11.4138 11.0366L11.8276 10.1262ZM16.0862 13.1604C16.589 13.3889 17.1818 13.1666 17.4104 12.6638C17.6389 12.161 17.4166 11.5682 16.9138 11.3396L16.0862 13.1604ZM5.9138 13.1604L10.5862 11.0366L9.75859 9.21582L5.0862 11.3396L5.9138 13.1604ZM11.4138 11.0366L16.0862 13.1604L16.9138 11.3396L12.2414 9.21582L11.4138 11.0366ZM10.5862 11.0366C10.8491 10.917 11.1509 10.917 11.4138 11.0366L12.2414 9.21582C11.4526 8.85728 10.5474 8.85728 9.75859 9.21582L10.5862 11.0366Z'
                fill='white'
            />
            <path
                id='Vector 209'
                d='M5.0862 18.8396C4.58342 19.0682 4.3611 19.661 4.58963 20.1638C4.81817 20.6666 5.41102 20.8889 5.9138 20.6604L5.0862 18.8396ZM10.1724 17.6262L10.5862 18.5366V18.5366L10.1724 17.6262ZM11.8276 17.6262L11.4138 18.5366L11.8276 17.6262ZM16.0862 20.6604C16.589 20.8889 17.1818 20.6666 17.4104 20.1638C17.6389 19.661 17.4166 19.0682 16.9138 18.8396L16.0862 20.6604ZM5.9138 20.6604L10.5862 18.5366L9.75859 16.7158L5.0862 18.8396L5.9138 20.6604ZM11.4138 18.5366L16.0862 20.6604L16.9138 18.8396L12.2414 16.7158L11.4138 18.5366ZM10.5862 18.5366C10.8491 18.417 11.1509 18.417 11.4138 18.5366L12.2414 16.7158C11.4526 16.3573 10.5474 16.3573 9.75859 16.7158L10.5862 18.5366Z'
                fill='white'
            />
            <path
                id='Vector 210'
                d='M5.0862 26.3396C4.58342 26.5682 4.3611 27.161 4.58963 27.6638C4.81817 28.1666 5.41102 28.3889 5.9138 28.1604L5.0862 26.3396ZM10.1724 25.1262L10.5862 26.0366V26.0366L10.1724 25.1262ZM11.8276 25.1262L11.4138 26.0366L11.8276 25.1262ZM16.0862 28.1604C16.589 28.3889 17.1818 28.1666 17.4104 27.6638C17.6389 27.161 17.4166 26.5682 16.9138 26.3396L16.0862 28.1604ZM5.9138 28.1604L10.5862 26.0366L9.75859 24.2158L5.0862 26.3396L5.9138 28.1604ZM11.4138 26.0366L16.0862 28.1604L16.9138 26.3396L12.2414 24.2158L11.4138 26.0366ZM10.5862 26.0366C10.8491 25.917 11.1509 25.917 11.4138 26.0366L12.2414 24.2158C11.4526 23.8573 10.5474 23.8573 9.75859 24.2158L10.5862 26.0366Z'
                fill='white'
            />
        </svg>
    );
};

export default IconLead;
